import { createContext } from "react";

type FeaturesFormContextProps = {
  formData: unknown | null;
  updateFeatureForm: (value: unknown|null) => void;
}

export const FeaturesFormContext = createContext<FeaturesFormContextProps>({
  formData: null,
  updateFeatureForm: (value) => {value}
});